import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { useStyleStore } from "@vcl";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Text color of the *selected* pill (and "Filters" label). Unselected text is
// a separate option so a high-contrast selected color can't hide resting pills.
export default class FilterToolbarFontColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Filter Selected Pill Text Color",
    component: inspectorTools.COLOR_PICKER,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      width: "fill",
      colorContext: "Fonts",
    },
  };

  static defaultValue = {
    value: "standard",
    source: "theme.font",
  };

  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];

    if (typeof themeMode === "object") {
      themeMode = "inherit";
    }

    if (configValue.source && configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue?.value;
  }
}
